import { render } from "./App.vue?vue&type=template&id=daace3ae"
const script = {}
script.render = render

export default script